module.exports = __webpack_public_path__ + "static/media/pokebackground.901f4612.svg";